'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = create;

var _isArray = require('lodash/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isFunction = require('lodash/isFunction');

var _isFunction2 = _interopRequireDefault(_isFunction);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ConfigStorage = function () {
	function ConfigStorage(defaultValue) {
		_classCallCheck(this, ConfigStorage);

		this._defaultValue = defaultValue;
		this._storage = defaultValue;
	}

	_createClass(ConfigStorage, [{
		key: 'get',
		value: function get(key) {
			return key ? this._storage[key] : this._storage;
		}
	}, {
		key: 'set',
		value: function set(value) {
			this._storage = value || this._defaultValue;
		}
	}, {
		key: 'add',
		value: function add(key, value) {
			if (typeof value === 'undefined') value = key;
			if ((0, _isArray2.default)(this._storage)) {
				this._storage.push(value);
			} else if ((0, _isObject2.default)(this._storage)) {
				this._storage[key] = value;
			} else if ((0, _isFunction2.default)(this._storage)) {
				// add property
				if (value) {
					Object.defineProperty(this._storage, key, {
						enumerable: true,
						configurable: true,
						get: value
					});
				}
			} else {
				this._storage = value;
			}
			return value;
		}
	}]);

	return ConfigStorage;
}();

function create(defaultValue) {
	return new ConfigStorage(defaultValue);
}


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/core/internal/config-storage.js
// module id = 92
// module chunks = 0 1